import { createSlice } from '@reduxjs/toolkit';
import { resetApplication } from '../application/slice';
import contactsState from './state';
const contactsSlice = createSlice({
    extraReducers: builder => {
        builder.addCase(resetApplication, () => contactsState);
    },
    initialState: contactsState,
    name: 'contacts',
    reducers: {
        errorReceiveContacts: state => {
            state.contacts = undefined;
            state.requestingContacts = false;
        },
        errorReceiveCreateContact: state => {
            state.requestingCreateContact = false;
        },
        errorReceiveModifyContact: state => {
            state.requestingModifyContact = false;
        },
        errorReceiveRemoveContact: state => {
            state.requestingRemoveContact = false;
        },
        failedReceiveContacts: state => {
            state.contacts = undefined;
            state.requestingContacts = false;
        },
        failedReceiveCreateContact: state => {
            state.requestingCreateContact = false;
        },
        failedReceiveModifyContact: state => {
            state.requestingModifyContact = false;
        },
        failedReceiveRemoveContact: state => {
            state.requestingRemoveContact = false;
        },
        receiveContacts: {
            prepare: contacts => {
                return {
                    payload: {
                        contacts
                    }
                };
            },
            reducer: (state, action) => {
                const { contacts } = action.payload;
                state.contacts = contacts;
                state.requestingContacts = false;
            }
        },
        receiveCreateContact: {
            prepare: contact => {
                return {
                    payload: {
                        contact
                    }
                };
            },
            reducer: (state, action) => {
                const { contact } = action.payload;
                state.contacts = state.contacts ? [...state.contacts, contact] : [contact];
                state.requestingCreateContact = false;
            }
        },
        receiveModifyContact: {
            prepare: (contact, consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI,
                        contact
                    }
                };
            },
            reducer: (state, action) => {
                const { consumerAPI, contact } = action.payload;
                state.contacts = state.contacts.map(value => {
                    let id;
                    let contactId;
                    if (consumerAPI) {
                        ({
                            id: contactId
                        } = contact);
                        ({
                            id
                        } = value);
                    }
                    else {
                        ({
                            contact_id: contactId
                        } = contact);
                        ({
                            contact_id: id
                        } = value);
                    }
                    return id === contactId ? contact : value;
                });
                state.requestingModifyContact = false;
            }
        },
        receiveRemoveContact: {
            prepare: (contactId, consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI,
                        contactId
                    }
                };
            },
            reducer: (state, action) => {
                const { consumerAPI, contactId } = action.payload;
                state.contacts = state.contacts.filter(value => {
                    let id;
                    if (consumerAPI) {
                        ({
                            id
                        } = value);
                    }
                    else {
                        ({
                            contact_id: id
                        } = value);
                    }
                    return id !== contactId;
                });
                state.requestingRemoveContact = false;
            }
        },
        requestContacts: {
            prepare: (consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI
                    }
                };
            },
            reducer: state => {
                state.requestingContacts = true;
            }
        },
        requestCreateContact: {
            prepare: (contactPayload, consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI,
                        contactPayload
                    }
                };
            },
            reducer: state => {
                state.requestingCreateContact = true;
            }
        },
        requestModifyContact: {
            prepare: (contactId, contactPayload, consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI,
                        contactId,
                        contactPayload
                    }
                };
            },
            reducer: state => {
                state.requestingModifyContact = true;
            }
        },
        requestRemoveContact: {
            prepare: (contactId, consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI,
                        contactId
                    }
                };
            },
            reducer: state => {
                state.requestingRemoveContact = true;
            }
        },
        resetContacts: () => contactsState
    }
});
export const { errorReceiveContacts, errorReceiveCreateContact, errorReceiveModifyContact, errorReceiveRemoveContact, failedReceiveContacts, failedReceiveCreateContact, failedReceiveModifyContact, failedReceiveRemoveContact, receiveContacts, receiveCreateContact, receiveModifyContact, receiveRemoveContact, requestContacts, requestCreateContact, requestModifyContact, requestRemoveContact, resetContacts } = contactsSlice.actions;
export default contactsSlice.reducer;
